import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Resets scroll to the top of the page whenever the route changes, so every
 * module opens at the top instead of inheriting the previous page's scroll
 * position. Rendered once inside the Router in App.js.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
